import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import getTelmexStatus from 'services/getTelmexStatus';
import { ModalError } from 'components/Error/ErrorModal';
import { decodeStorage } from 'functions/storageBase64';
import { postClaroScore } from 'services/claroScore';
import getShipping from 'services/getShipping';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { ProgressBar } from 'components/ProgressBar';
import { useStorage64 } from 'hooks/useStorageBase64';


export function OcupacionIncode() {

    const history = useHistory();
    const { isMobile } = useIsMobile();

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    const EXTERNO = decodeStorage('EXTERNO')

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.scrollTo(0, 0);
        window.ineum('page', 'Telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const datosPersonalesStorage = decodeStorage("infoPersonalStorageIncode")
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);

    const [, setInfoOcupacionStorage] = useStorage64('infoOcupacionStorage', '');
    const [shipping, setShupping] = useState({});
    const [inputCalle, setInputCalle] = useState();
    const [inputCP, setInputCP] = useState(datosPersonales?.CPEmp);
    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [colonia, setColonia] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();

    const [dataOcupaciones,] = useState([
        {title:"Profesionista", val: "01"},
        {title:"Ejecutivo de Negocio", val: "02"},
        {title:"Cuenta propia", val: "03"},
        {title:"Profesionales", val: "04"},
        {title:"Ventas", val: "05"},
        {title:"Labores clasificadas", val: "06"},
        {title:"Mano de obra no clasificada", val: "07"},
        {title:"Oficinista", val: "08"}
    ]);

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            ocupacion: ""
        }
    })

    const valOcupacion = {
        required: 'Campo obligatorio',
    };
    
    const [ocupacion, setOcupacion] = useState(false);
    const seleccionarOcupacion = (e) => {
        setOcupacion(e.target.value);
    }

     // consulta get Telmex
     const handleInformacionIne = data => {
        
        console.log("data form",data);

        setInfoOcupacionStorage({
            "Ocupacion": data.ocupacion,
        })

        history.push(`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-ingreso`);
    }




    return (
        <>
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
            {
                EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
            }
                <main className='nuevoCredito ultimosPasos'>
                    <ProgressBar progress={40} />
                    
                    <h1 className='bold fontsize18 texto'>¿Cuál es tu ocupación?</h1>

                    <div className='contenidoSolicitarTarjeta fullBottom'>
                        <form onSubmit={handleSubmit(handleInformacionIne)}>
                            
                            <div className="viviendaBox">
                                <div className="subCampo">
                                    <ul className="ulOcupacion" onChange={seleccionarOcupacion}>
                                        {dataOcupaciones.map((item,index)=>
                                            <li key={index}>
                                                <label name={item.title} htmlFor={item.title}>{item.title}</label>
                                                <input className="radio" id={item.title} type="radio" value={item.val} name="ocupacion"  ref={register(valOcupacion)} />
                                            </li>
                                        )}
                                    </ul>
                                    <div className="secEmpleo">
                                        <div className="campo boxSexo">
                                            {ocupacion === false && errors.ocupacion && errors.ocupacion.message
                                                ? <div className="error">Campo obligatorio</div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div className="boxBtnSolicitar top">
                        <button className="btnSolicitar" onClick={handleSubmit(handleInformacionIne)}> Continuar</button>
                    </div>
                </main>
            </div>
        </>
    )
}